<template>
  <div class="lay" @click="handleClick" :style="cellStyle">
    <i v-if="isArrow" :class="iconName" style="margin-right: 12px;"></i>
    <Checkbox v-if="isCheckbox" v-model="checked" :name="data.id" :ids.sync="ids"  style="margin-right: 12px;" />
    <Headimg v-if="isHeadimg" :data="{name: data.name, url: avatar}" style="margin-right: 12px;" />
    <div v-if="isEndLine" class="end center" :style="endStyle">
      {{ data.name }}
    </div>
    <div v-else class="end" :style="endStyle">
      <div>
        {{ data.name }}
        <span v-if="data.orgCode || data.roleCode">
          <span v-if="count && count[data.id]" class="count">(已选{{ count[data.id] }})</span>
        </span>
      </div>
      <div class="gray" v-if="data.nickName">{{data.nickName}}</div>
      <div class="gray" v-if="data.orgType">{{data.orgType}}</div>
      <div class="gray" v-if="data.roleCode">{{data.roleCode}}</div>
    </div>
    <div :class="[down ? 'down gray': 'down']" v-if="(data.orgCode || data.roleCode) && isDown" @click.stop="handleDown">
      下级
    </div>
    <div :class="[down ? 'down gray': 'down']" v-if="(data.orgCode || data.roleCode) && isDel" @click.stop="handleDel">
      删除
    </div>
  </div>
</template>

<script>
import Checkbox from './checkbox'
import itemMixin from './mixins/item'
import Headimg from '../common/headimg'
export default {
  mixins: [itemMixin],
  props: {
    iconName: {
      type: String,
      default: 'el-icon-arrow-right'
    },
    cellStyle: {
      type: Object
    },
    endStyle: {
      type: Object
    }
  },
  components: {
    Checkbox,
    Headimg
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.lay {
  display: flex;
  padding:0 12px;
  height: 60px;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.lay:hover {
  background-color: #F5F7FA;
}

.end {
  border-bottom: 1px solid #eee;
  flex: 1;
  width: auto;
  height: 44px;
}
.center {
  display: flex;
  align-items: center;
}
.gray {
  white-space:nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  color: #CCC;
}
.count {
  font-size: 10px;
  color: #666;
}
.down {
  position: absolute;
  right: 0;
  padding: 12px;
}
</style>
